import { render, staticRenderFns } from "./TrendingPostsSlidegroup.vue?vue&type=template&id=6463f845&scoped=true"
import script from "./TrendingPostsSlidegroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingPostsSlidegroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrendingPostsSlidegroup.vue?vue&type=style&index=0&id=6463f845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463f845",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTrendingPostsTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/trending-posts/TrendingPostsTile.vue').default,CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CSlideItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideItem.vue').default,CLtkSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkSlideGroup/CLtkSlideGroup.vue').default})
